import ApiService from './api.service';
export default class AnnouncementsService {
    apiService;
    constructor(ControlCenterApiUrl) {
        this.apiService = new ApiService(ControlCenterApiUrl);
    }
    getUserAnnouncements = async (userUuid, unreadOnly = true) => {
        const url = `/api/v1/announcements/users/${userUuid}/announcements`;
        try {
            const response = await this.apiService.get(url, { unreadOnly });
            return response?.data || {};
        }
        catch (error) {
            console.log(error);
        }
    };
    getAnnouncementEmails = async (userUuid) => {
        const url = `/api/v1/announcements/AnnouncementsEmail/${userUuid}`;
        try {
            const response = await this.apiService.get(url);
            return response?.data || {};
        }
        catch (error) {
            console.log(error);
        }
    };
    getTimeZone = async () => {
        try {
            const response = await this.apiService.get('api/v1/account/timezones');
            return Array.isArray(response?.data) ? response?.data : [];
        }
        catch (error) {
            console.log(error);
        }
    };
    updateAnnouncementEmails = async (userUuid, updatedEmailAddresses) => {
        const requestBody = {
            addresses: updatedEmailAddresses,
        };
        try {
            const response = await this.apiService.put(`/api/v1/announcements/AnnouncementsEmail/${userUuid}`, requestBody);
            return response?.data || {};
        }
        catch (error) {
            console.log(error);
        }
    };
}
